import { createClient, OASClient, type NormalizeOAS } from 'fets';
import type openapi from './asset-library-open-api';
import { AuthPlugin } from './fetsAuthPlugin';

export type AssetLibraryFetsApiClient = OASClient<NormalizeOAS<typeof openapi>>;

export const createAssetLibraryFetsClient = (
  backendUrl: string,
  provideAuthTokenFunc: () => Promise<string>
): AssetLibraryFetsApiClient => {
  const apiClient = createClient<NormalizeOAS<typeof openapi>>({
    endpoint: backendUrl,
    plugins: [AuthPlugin(provideAuthTokenFunc)],
  });

  return apiClient;
};
